import { FaArrowLeftLong } from "react-icons/fa6";
export const BackIcon = ({ onCLick }: { onCLick: () => void }) => (
  <div onClick={onCLick}>
    <div className="flex items-center gap-1 sm:gap-2">
      <FaArrowLeftLong size={18} className="cursor-pointer" /> <span className="text-base-input">|</span> <div />
    </div>
  </div>
);
